var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 284.3 28",
    style: {
      enableBackground: "new 0 0 284.3 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,28H0V0h5.3v23.5h11.9V28z M39.1,28H20.9V0h18v4.2h-13v7.6h10.4v4.1H26v7.8h13.1V28z M48.6,28h-5.2V0h17.7v4.3H48.6 v7.6h9.8v4.2h-9.8V28z M74.6,28h-5.4V4.4h-7.4V0h20.3v4.3h-7.4L74.6,28L74.6,28z M112.8,28H95.6V0h5.3v23.5h11.9 C112.8,23.5,112.8,28,112.8,28z M134.7,28h-18.2V0h18v4.2h-13v7.6h10.4v4.1h-10.4v7.8h13.1V28H134.7z M161,28h-5.4l-2.2-6.7h-10.8 l-2.2,6.7h-4.3l9.3-28h6.2L161,28z M152.1,17.3L148,4.8l-4.1,12.5H152.1z M185.5,28h-4.9L170,10.1c-0.2-0.3-0.4-0.7-0.8-1.3 c-0.1-0.3-0.4-0.7-0.7-1.3V28h-4.1V0h5.6l9.8,16.5c0.1,0.1,0.7,1.1,1.8,3V0h4v28H185.5z M219.4,28h-17.2V0h5.3v23.5h11.9V28z  M241.3,28h-18.2V0h18v4.2h-13v7.6h10.4v4.1h-10.4v7.8h13.1L241.3,28L241.3,28z M250.9,28h-5.2V0h17.7v4.3h-12.5v7.6h9.8v4.2h-9.8 V28z M276.8,28h-5.4V4.4H264V0h20.3v4.3h-7.4V28H276.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLll);
export default __webpack_public_path__ + "static/media/LLL.6eccd9e29da2552d9e26afbf9ee96423.svg";
export { ForwardRef as ReactComponent };